import { TResources } from "app/queryProvider/interfaces";
import { API_ROUTE_VERSION } from "./resources";

const getResourceName = (resource: TResources): TResources => {
    if (resource.includes("/")) {
      const parts = resource.split("/");
      return parts[parts.length - 1] as TResources;
    }
    return resource;
  };

const getResourceVersion = (resource: TResources): string | null => {
    return API_ROUTE_VERSION[resource]?.version ?? null;
    };

export const generateCRUDResourceUrl = (resource: { name: TResources; id?: string}): string => {
    const resourceName = getResourceName(resource.name);
    const resourceVersion = getResourceVersion(resourceName);
    const microService = API_ROUTE_VERSION[resourceName].microService;
    const resourceUrl = resourceVersion ? `${microService}/api/${resourceVersion}/${resourceName}` : `${microService}/api/${resourceName}`;
    if (resource.id) {
      return `${resourceUrl}/${resource.id}`;
    }
    return resourceUrl;
  };

export const generateUrl = (resource: { name: TResources; id?: string }, urlPath: string): string => {
    const crudResource = generateCRUDResourceUrl(resource)
    const path = urlPath
    return `${crudResource}${path}`
}
